import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataFieldEditModule } from '@fi-app/data-field/data-field-edit/data-field-edit.module';
import { FormsModule } from '@angular/forms';
import { ComponentsModule } from '@fi-app/components/components.module';
import { BusinessUnitLockedInformationModule } from '../business-unit-locked-information/business-unit-locked-information.module';
import { UtilitiesModule } from '@fi-app/utilities/utilities.module';
import { FiQRCodeViewModule } from '@fi-shared/fi-qr-code-view/qr-code-view.module';
import { FiBusinessUnitQRCodeViewComponent } from './business-unit-qr-code-view/business-unit-qr-code-view.component';
import { MatCardModule } from '@angular/material/card';
import { FiBusinessUnitEditNewLayoutComponent } from './fi-business-unit-edit-new-layout/fi-business-unit-edit-new-layout.component';
import { FiBusinessUnitEditInformationComponent } from './fi-business-unit-edit-new-layout/fi-business-unit-edit-information/fi-business-unit-edit-information.component';
import { FiBusinessUnitEditStatusComponent } from './fi-business-unit-edit-new-layout/fi-business-unit-edit-status/fi-business-unit-edit-status.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FiBusinessUnitEditLocationAndContactTabComponent } from './fi-business-unit-edit-new-layout/fi-business-unit-edit-location-and-contact-tab/fi-business-unit-edit-location-and-contact-tab.component';
import { MatDividerModule } from '@angular/material/divider';
import { FiBusinessUnitEditOtherTabComponent } from './fi-business-unit-edit-new-layout/fi-business-unit-edit-other-tab/fi-business-unit-edit-other-tab.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ComponentsModule,
        UtilitiesModule,
        BusinessUnitLockedInformationModule,
        DataFieldEditModule,
        FiQRCodeViewModule,
        MatCardModule,
        MatTabsModule,
        MatIconModule,
        MatButtonModule,
        MatDividerModule,
    ],
    declarations: [
        FiBusinessUnitQRCodeViewComponent,
        FiBusinessUnitEditNewLayoutComponent,
        FiBusinessUnitEditInformationComponent,
        FiBusinessUnitEditStatusComponent,
        FiBusinessUnitEditLocationAndContactTabComponent,
        FiBusinessUnitEditOtherTabComponent,
    ],
    exports: [FiBusinessUnitQRCodeViewComponent],
})
export class BusinessUnitEditModule {}
